import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
// Local testing only: when served from localhost (Firebase hosting emulator),
// talk to the local emulators instead of production. Production hostnames never
// match, so the deployed bundle is unaffected.
const ON_LOCALHOST = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);


const firebaseConfig = {
  apiKey: "AIzaSyDM9LfaAvcguPThVSl9LhRbYiBtse0O5zo",
  authDomain: "agriware-hq.firebaseapp.com",
  projectId: "agriware-hq",
  storageBucket: "agriware-hq.firebasestorage.app",
  messagingSenderId: "590642472140",
  appId: "1:590642472140:web:5fe8886b59c90106248e69"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west2');

if (ON_LOCALHOST) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9097', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8081);
  connectStorageEmulator(storage, '127.0.0.1', 9197);
  connectFunctionsEmulator(functions, '127.0.0.1', 5003);
}

export default app;
